import { fromPairs } from 'lodash';
import { schemeCategory10 } from 'd3-scale-chromatic';

export function generateColorMap(graphData: { id: string }[]) {
  const colors = graphData.map((d, i) => [d.id, schemeCategory10[i % schemeCategory10.length]]);
  return fromPairs(colors);
}
